import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { ComponentBase } from '../../../abstracts/component-base';

@Component({
  selector: 'app-blackboxes',
  templateUrl: './blackboxes.component.html',
  styleUrls: ['./blackboxes.component.scss']
})
export class BlackboxesComponent extends ComponentBase implements OnInit {

  public className = 'ChargingStationsComponent';
  public activeTab = 'summary';
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public showAll: boolean = false;
  public activeComponentClassName: string;

  public links = [
    { title: $localize`:@@ManageTitel1:Ladestationen`, route: 'summary' },
    { title: $localize`:@@ManageTitel2:Ladestationsgruppen`, route: 'groups' }
  ];

  constructor(
    public tableFunctions: TableFunctionsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.showAll = this.activatedRoute.snapshot.data['showAll'];
    super.ngOnInit();
    this.determineActiveTab();
    this.getRoles();
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
  }

  public onRouterOutletActivate(event: any) {
    this.activeComponentClassName = event.className;
  }

  determineActiveTab() {
    for (let link of this.links) {
      if (this.router.url.includes(link.route)) {
        this.activeTab = link.route;
      }
    }
  }
}
